// Chip prompts append `<ctx:KEY=VALUE>` markers so the agent can route without
// the user re-supplying ids. They're for the LLM — strip them from the bubble
// and surface a quiet "+N key" hint instead.
const CTX_MARKER_RE = /\s*<ctx:([a-z_][a-z0-9_]*)=([^>]*)>\s*/gi;

// The clarify-form submit marker (`fields=…`) duplicates the values already
// shown in the bubble text, and the hint is non-interactive — so strip it
// from the text like any marker, but don't render a "+N fields" chip for it.
const SILENT_MARKER_KEYS = new Set(['fields']);

interface CtxMarker {
  key: string;
  count: number;
}

export const splitUserContent = (
  raw: string
): { visible: string; markers: CtxMarker[] } => {
  const markers: CtxMarker[] = [];
  const visible = raw
    .replace(CTX_MARKER_RE, (_, key: string, value: string) => {
      const normalized = key.toLowerCase();
      if (SILENT_MARKER_KEYS.has(normalized)) return '';
      const items = value
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      markers.push({ key: normalized, count: items.length });
      return '';
    })
    .trim();
  return { visible, markers };
};
